import React, { useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import ExportInvoice from "./modules/billing/ExportInvoice";
import VATInvoice from "./modules/billing/VATInvoice";
import GSTRegisterIndia from "./modules/registers/GSTRegisterIndia";
import TaxRegisterOverseas from "./modules/registers/TaxRegisterOverseas";
import { uaeInvoices, uaeReverseCharge } from "./data/dummyUAE";
import { indiaExportInvoices } from "./data/dummyIndia";

const PDInvoiceGlobal = ({ subscription, taxMeta, countryCode = "AE" }) => {
    const [selectedMenu, setSelectedMenu] = useState("exportInvoice");

    if (!subscription) return null;
    if (!taxMeta) return null;

    const handleDownload = () => {

        const pdf = new jsPDF("p", "mm", "a4");
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(16);
        let y = 20;

        switch (selectedMenu) {
            case "exportInvoice":
                pdf.text("EXPORT INVOICE", 10, y);
                y += 10;
                pdf.setFontSize(10);
                pdf.setFont("helvetica", "normal");
                pdf.text(
                    `Invoice No: ${subscription.invoiceNumber || "-"}`,
                    10,
                    y
                );

                y += 6;
                pdf.text(
                    `Distributor: ${
                        subscription.distributorName ||
                        "Missing Distributor Name"
                    }`,
                    10,
                    y
                );

                y += 6;

                pdf.text(
                    `Country: ${countryCode || "-"}`,
                    10,
                    y
                );

                y += 6;

                pdf.text(
                    `Product: ${subscription.product || "-"}`,
                    10,
                    y
                );

                y += 6;

                pdf.text(
                    `Amount: ${subscription.currencySymbol || ""}${Number(
                        subscription.finalAmount || 0
                    ).toFixed(2)}`,
                    10,
                    y
                );

                y += 6;

                pdf.text(
                    `GST: 0% (Export under LUT)`,
                    10,
                    y
                );

                break;

            case "vatInvoice":

                const gross =
                    Number(subscription.finalAmount || 0);

                const vatRate =
                    Number(subscription.vatRate || 5);

                const vat =
                    gross * vatRate / 100;

                const total =
                    gross + vat;

                pdf.text("VAT INVOICE", 10, y);

                y += 10;

                pdf.setFontSize(10);

                pdf.text(
                    `Customer: ${subscription.userName || "-"}`,
                    10,
                    y
                );

                y += 6;

                pdf.text(
                    `Product: ${subscription.product || "-"}`,
                    10,
                    y
                );

                y += 6;

                pdf.text(
                    `Net Amount: ${gross.toFixed(2)}`,
                    10,
                    y
                );

                y += 6;

                pdf.text(
                    `VAT ${vatRate}%: ${vat.toFixed(2)}`,
                    10,
                    y
                );

                y += 6;

                pdf.text(
                    `Total: ${total.toFixed(2)}`,
                    10,
                    y
                );

                break;

            case "gstRegister":
                pdf.setFontSize(16);
                pdf.text("India GST Export Register", 10, 15);

                y = 30;

                pdf.setFontSize(9);

                pdf.text("Invoice", 10, y);
                pdf.text("Date", 35, y);
                pdf.text("Customer", 60, y);
                pdf.text("Country", 110, y);
                pdf.text("Amount", 145, y);
                pdf.text("Currency", 170, y);

                y += 6;

                pdf.line(10, y, 195, y);

                y += 5;

                indiaExportInvoices.forEach((row) => {

                    if (y > 270) {
                        pdf.addPage();

                        y = 20;

                        pdf.setFontSize(9);

                        pdf.text("Invoice", 10, y);
                        pdf.text("Date", 35, y);
                        pdf.text("Customer", 60, y);
                        pdf.text("Country", 110, y);
                        pdf.text("Amount", 145, y);
                        pdf.text("Currency", 170, y);

                        y += 8;
                    }

                    pdf.text(
                        String(row.id),
                        10,
                        y
                    );

                    pdf.text(
                        String(row.date),
                        35,
                        y
                    );

                    pdf.text(
                        String(row.customer).substring(0, 25),
                        60,
                        y
                    );

                    pdf.text(
                        String(row.country),
                        110,
                        y
                    );

                    pdf.text(
                        String(row.amount),
                        145,
                        y
                    );

                    pdf.text(
                        String(row.currency),
                        170,
                        y
                    );

                    y += 7;
                });

                y += 10;

                pdf.setFontSize(11);

                pdf.text(
                    "Export Of Services Under LUT / Bond",
                    10,
                    y
                );

                y += 6;

                pdf.text(
                    `Total Invoices: ${indiaExportInvoices.length}`,
                    10,
                    y
                );

                y += 6;

                pdf.text(
                    `Supplier GSTIN: ${taxMeta?.GSTNo || "-"}`,
                    10,
                    y
                );

                y += 6;

                pdf.text(
                    `SAC: ${taxMeta?.HSNCode || "-"}`,
                    10,
                    y
                );

                break;

            case "vatRegister":
                pdf.setFontSize(16);
                pdf.text("UAE Sales VAT Register", 10, 15);

                y = 30;

                pdf.setFontSize(10);

                // Header
                pdf.text("Customer", 10, y);
                pdf.text("Net", 80, y);
                pdf.text("VAT", 120, y);
                pdf.text("Total", 160, y);

                y += 8;

                uaeInvoices.forEach((row) => {
                    pdf.text(String(row.customer), 10, y);
                    pdf.text(String(row.amount), 80, y);
                    pdf.text(String(row.vat), 120, y);
                    pdf.text(String(row.total), 160, y);
                    y += 8;
                });

                y += 15;

                pdf.setFontSize(16);
                pdf.text("Reverse Charge Register", 10, y);

                y += 12;

                pdf.setFontSize(10);

                pdf.text("Supplier", 10, y);
                pdf.text("Service", 70, y);
                pdf.text("Value", 130, y);
                pdf.text("VAT", 170, y);

                y += 8;

                uaeReverseCharge.forEach((row) => {
                    pdf.text(String(row.supplier), 10, y);
                    pdf.text(String(row.service), 70, y);
                    pdf.text(String(row.value), 130, y);
                    pdf.text(String(row.vat), 170, y);
                    y += 8;
                });

                break;

            default:
                break;
        }

        pdf.save(
            `${selectedMenu}-${subscription.invoiceNumber || "report"}.pdf`
        );
    };

    const handleShare = async () => {
        const message = `
PD Tax System

Invoice: ${subscription.invoiceNumber || "-"}
Customer: ${subscription.userName || "-"}
        `.trim();

        if (navigator.share) {
            try {
                await navigator.share({
                    title: "PD Tax",
                    text: message,
                });
            } catch (err) {
                console.log(err);
            }
        }
    };

    const handleEmail = () => {
        window.location.href = "mailto:?subject=PD Tax Report&body=Please find attached report.";
    };

    const renderComponent = () => {
        switch (selectedMenu) {
            case "exportInvoice":
                return (
                    <ExportInvoice
                        subscription={subscription}
                        taxMeta={taxMeta}
                        countryCode={countryCode}
                    />
                );

            case "vatInvoice":
                return (
                    <VATInvoice
                        subscription={subscription}
                        taxMeta={taxMeta}
                        countryCode={countryCode}
                    />
                );

            case "gstRegister":
                return (
                    <GSTRegisterIndia
                        taxMeta={taxMeta}
                    />
                );

            case "overseasTaxRegister":
                return (
                    <TaxRegisterOverseas 
                        taxMeta={taxMeta}
                    />
                );
            default: return null;
        }
    };

    const handleJsonExport = () => {
        const exportData = {
            exportedAt: new Date().toISOString(),
            reportType: selectedMenu,
            uaeInvoices,
            uaeReverseCharge
        };
        const jsonString = JSON.stringify(exportData, null,2);
        const blob = new Blob(
            [jsonString],
            {
                type: "application/json"
            }
        );
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download =`${selectedMenu}-${Date.now()}.json`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    return (
        <div className="mt-4 border border-purple-700 rounded-xl overflow-hidden bg-[#111827]">
            <div className="bg-purple-900/30 border-b border-purple-700 p-4 flex justify-between items-center">
                <div className="grid grid-cols-4 gap-3 text-gray-200 text-xs">
                    <button onClick={handleDownload}>⬇️</button>
                    <button onClick={handleShare}>🔗</button>
                    <button onClick={handleEmail}>✉️</button>
                    <button onClick={handleJsonExport}>JSON</button>
                </div>
            </div>
            <div className="p-4 border-b border-purple-700 flex flex-wrap gap-2">
                <button
                    onClick={() => setSelectedMenu("exportInvoice")}
                    className={`px-2 py-1 w-32 rounded text-xs ${
                        selectedMenu === "exportInvoice"
                            ? "bg-cyan-500 text-black"
                            : "bg-gray-800 text-white"
                    }`}
                >
                    Export Invoice
                </button>

                <button
                    onClick={() => setSelectedMenu("vatInvoice")}
                    className={`px-2 py-1 w-32 rounded text-xs ${
                        selectedMenu === "vatInvoice"
                            ? "bg-cyan-500 text-black"
                            : "bg-gray-800 text-white"
                    }`}
                >
                    VAT Invoice
                </button>

                {/* <button
                    onClick={() => setSelectedMenu("gstRegister")}
                    className={`px-2 py-1 w-32 rounded text-xs ${
                        selectedMenu === "gstRegister"
                            ? "bg-cyan-500 text-black"
                            : "bg-gray-800 text-white"
                    }`}
                >
                    India GST Register
                </button>

                <button
                    onClick={() => setSelectedMenu("overseasTaxRegister")}
                    className={`px-2 py-1 w-48 rounded text-xs ${
                        selectedMenu === "vatRegister"
                            ? "bg-cyan-500 text-black"
                            : "bg-gray-800 text-white"
                    }`}
                >
                    Overseas Tax Register
                </button> */}
            </div>

            <div id="pd-tax-content" className="p-4">
                {renderComponent()}
            </div>
        </div>
    );
};

export default PDInvoiceGlobal;